<template>
  <div class="divider">
    <span>{{ text || $t('lbl_emp2_OR') }}</span>
  </div>
</template>

<script>
export default {
  name: 'Divider',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.divider {
  align-self: stretch;
  justify-content: center;
  align-items: center;
  gap: 24px;
  display: inline-flex;
  margin: 0;
  padding: 0;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1 1 0;
  height: 1px;
  position: relative;
  border: 1px rgba(0, 0, 0, 0.10) solid;
  background: transparent;
}

.divider span {
  text-box-trim: trim-both;
  text-box-edge: cap alphabetic;
  color: rgba(0, 0, 0, 0.50);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  line-height: 14px;
  word-wrap: break-word;
}
</style>

<!-- 特殊场景样式，通过 deep 选择器覆盖 -->
<style>
/* condensed-step 中的 divider 间距调整 */
.login-step.condensed-step .divider {
  gap: 12px;
}

/* OTP 步骤中的 divider margin 调整 */
.login-step-otp .divider {
  margin: 0;
}
</style>

